import { graphql } from '../gql'

export const SEARCH_PRODUCTS_QUERY = graphql(`
  query SearchProducts($input: SearchInput!) {
    search(input: $input) {
      items {
        productId
        productVariantId
        productName
        slug
        sku
        price {
          ... on SinglePrice {
            value
          }
          ... on PriceRange {
            min
            max
          }
        }
        priceWithTax {
          ... on SinglePrice {
            value
          }
          ... on PriceRange {
            min
            max
          }
        }
        currencyCode
        productAsset {
          preview
        }
      }
      collections {
        collection {
          id
          name
          slug
          featuredAsset {
            preview
          }
        }
        count
      }
      facetValues {
        count
        facetValue {
          id
          name
          code
          facetId
          customFields
          facet {
            id
            name
            code
          }
        }
      }
      totalItems
    }
  }
`)
